import React, { ReactEventHandler } from 'react';
import {Form, Select } from 'antd';
import {SelectValue} from 'antd/lib/select'
const { Option } = Select;

type propTypes = {
    options?:string[],
    searchValue?:string,	
    label?:string,
    name?:string,
    onChange: (e:SelectValue,name:string) => void
  }

const DropDown = ({options,label,name,onChange}:propTypes) =>{
    return (
    <Form.Item label={label} name={name}>
        <Select allowClear onChange={ (e) => onChange(e,name ? name : '')}
         showSearch>
            {!!options?.length &&
                options.map((opt:string,idx:number)=>{
                    return (
                        <Option key={idx} value={opt}>{opt}</Option>
                    )
                })
            }    
        </Select>
    </Form.Item>
    )
}

export default DropDown